import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAdminAuth } from "@/lib/admin-auth";
import { Link } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { token, loading, login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-[#D4AF37] animate-spin" />
      </div>
    );
  }
  if (token) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) {
      setError("Add meg az e-mail címet és a jelszót.");
      return;
    }
    try {
      setSubmitting(true);
      await login(email, password);
      toast.success("Bejelentkezve");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Bejelentkezés sikertelen";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0A0A0A] text-[#F5F5F0] flex flex-col">
      <div className="px-6 md:px-12 py-6 border-b border-[#2A2A2A]">
        <Link to="/" data-testid="admin-login-back" className="inline-flex items-center gap-2 text-sm text-[#A3A3A3] hover:text-[#F5F5F0] transition">
          <ArrowLeft className="w-4 h-4" /> Vissza az oldalra
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="w-full max-w-md">
          <div className="text-center mb-10">
            <Lock className="w-8 h-8 text-[#D4AF37] mx-auto mb-4" strokeWidth={1.5} />
            <h1 className="font-serif-display text-4xl tracking-tight">Admin felület</h1>
            <p className="mt-3 text-sm text-[#A3A3A3]">Csak a stúdió tulajdonosának</p>
          </div>
          <form onSubmit={handleSubmit} data-testid="admin-login-form" className="bg-[#111111] border border-[#2A2A2A] rounded-sm p-8 space-y-5">
            <div>
              <label className="block text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-2">E-mail</label>
              <input
                type="email"
                data-testid="admin-login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                className="w-full bg-[#0A0A0A] border border-[#2A2A2A] focus:border-[#D4AF37] outline-none rounded-sm px-4 py-3 text-[#F5F5F0]"
              />
            </div>
            <div>
              <label className="block text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-2">Jelszó</label>
              <input
                type="password"
                data-testid="admin-login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className="w-full bg-[#0A0A0A] border border-[#2A2A2A] focus:border-[#D4AF37] outline-none rounded-sm px-4 py-3 text-[#F5F5F0]"
              />
            </div>
            {error && (
              <div data-testid="admin-login-error" className="text-sm text-red-400 bg-red-950/30 border border-red-900/50 rounded-sm px-3 py-2">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-[#D4AF37] hover:bg-[#C49A26] disabled:opacity-60 text-[#0A0A0A] py-3 rounded-sm font-semibold tracking-wide transition-all"
            >
              {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              {submitting ? "Belépés…" : "Bejelentkezés"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
